export { PageHeaderTemplate } from './PageHeaderTemplate'
export type { PageHeaderTemplateProps } from './PageHeaderTemplate.types'
